import { useWatch } from 'react-hook-form';

import { Typography } from '@mui/material';
import clsx from 'clsx';

import { getTranslatedInitialValue } from 'helpers/getTranslatedInitialValue';

import styles from './FieldTableRowTitle.module.scss';

export const FieldTableWatchedRowTitle: React.FC<{ watchRowTitleName: string; disabled?: boolean }> = ({
  watchRowTitleName,
  disabled,
}) => {
  const rowName: string = useWatch({ name: watchRowTitleName });

  return <FieldTableRowTitle title={rowName} disabled={disabled} />;
};

export const FieldTableRowTitle: React.FC<{ title?: string; disabled?: boolean }> = ({
  title = 'Untitled',
  disabled = false,
}) => {
  return (
    <Typography variant="subtitle2" className={clsx(styles.title, { [styles.disabled]: disabled })}>
      {getTranslatedInitialValue(title)}
    </Typography>
  );
};
